import axios from 'axios';
import notification from 'antd/es/notification';
import { Cookies } from 'react-cookie';
import { setGlobalPassChangeModalEv } from '../models/authModel/index.js';
// test rebuild

const apiRoot = __API_URL__;
export const cookies = new Cookies();

export const api = (auth = true) => {
  const axiosInstance = axios.create({
    baseURL: apiRoot,
    // withCredentials: true,
  });

  if (auth) {
    let access_token = cookies.get('access_token');
    if (window.location.pathname.includes('public-pages')) {
      access_token = localStorage.getItem('public_auth_token');
      axiosInstance.defaults.headers = {
        [__CKB_TOKEN_HEADER__]: access_token,
        'Access-Control-Expose-Headers': 'Content-Disposition',
      };
    } else {
      axiosInstance.defaults.headers = {
        Authorization: `Bearer ${access_token}`,
        'Access-Control-Expose-Headers': 'Content-Disposition',
      };
    }
  }

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      // if (
      //   error.request.responseURL.includes('refresh') &&
      //   error.response.status === 401
      // ) {
      //   cookies.remove('access_token', { path: '/' });
      //   cookies.remove('refresh_token', { path: '/' });
      //   window.location.href = '/login';
      //   return Promise.reject(error);
      // }

      if (error.request.status === 0) {
        notification.error({
          message: 'Ошибка',
          description: 'Ошибка сети',
          placement: 'topRight',
        });
        return Promise.reject(error);
      } else if (error.response.status === 401) {
        if (error.response.data.message === 'Password change required') {
          notification.error({
            message: 'Ошибка авторизации',
            description: 'Необходимо сменить пароль',
            placement: 'topRight',
          });
          setGlobalPassChangeModalEv(true);
          return Promise.reject(error);
        }

        if (error.response.data.message === 'User is blocked') {
          notification.error({
            message: 'Ошибка',
            description: 'Ваша учетная запись заблокирована',
            placement: 'topRight',
          });
          cookies.remove('access_token', { path: '/' });
          cookies.remove('refresh_token', { path: '/' });
          return Promise.reject(error);
        }

        if (error.response.data.message?.includes('заблокирован')) {
          notification.error({
            message: 'Ошибка',
            description: error.response.data.message,
            placement: 'topRight',
            duration: 10,
          });
          cookies.remove('access_token', { path: '/' });
          cookies.remove('refresh_token', { path: '/' });
          return Promise.reject(error);
        }

        if (window.location.pathname.includes('login')) {
          notification.error({
            message: 'Ошибка авторизации',
            description: 'Неверный логин или пароль',
            placement: 'topRight',
          });
          return Promise.reject(error);
        }

        cookies.remove('access_token', { path: '/' });
        const refreshToken = cookies.get('refresh_token');

        if (
          !refreshToken &&
          !(
            window.location.pathname.includes('public') ||
            window.location.pathname.includes('foreign-investments') ||
            window.location.pathname.includes('login')
          )
        ) {
          window.location.href = '/login';
        } else if (
          refreshToken &&
          !window.location.pathname.includes('login')
        ) {
          window.location.href = '/login';
        }
      }

      if (
        !window.location.pathname.includes('public') &&
        !window.location.pathname.includes('polls') &&
        error.response.status !== 401
      ) {
        notification.error({
          message: error.response.statusText,
          description: error.response.data.message,
          placement: 'topRight',
        });
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};
